import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const ENTITLED_STATUSES = new Set(["trialing", "active", "manual", "past_due"]);
const POLL_INTERVAL_MS = 1500;
const MAX_POLLS = 8;

export default function BillingSuccessPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      const { data } = await api.get("/auth/me");
      if (cancelled) return;
      setUser(data);
      if (ENTITLED_STATUSES.has(data.subscription_status)) {
        navigate("/");
        return;
      }
      if (attempt < MAX_POLLS) {
        setTimeout(() => setAttempt((a) => a + 1), POLL_INTERVAL_MS);
      } else {
        navigate("/");
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attempt]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center text-center px-6">
      <div className="animate-rise">
        <p className="font-heading font-bold text-2xl">Activating your account…</p>
        <p className="text-ink/50 mt-2 text-sm">This only takes a moment.</p>
      </div>
    </div>
  );
}
